import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import moment from "moment";
import { useOrderServiceTypes } from "../../../hooks";

const { Text } = Typography;
const ServiceDetails = (props) => {
  const { record, startOfTrom } = props;
  const [serviceType, setServiceType] = useState(null);
  const serviceTypes = useOrderServiceTypes();
  useEffect(() => {
    if (record && record.order_service_type_id) {
      const filtered = serviceTypes.filter(
        (i) => i.id === record.order_service_type_id
      )[0];
      setServiceType(filtered.name);
    }
  }, [serviceTypes, record]);
  const serviceText = "מהות הטיפול:";
  const startText = "הנ״ל החל/ה לקבל מאיתנו שרות טרום סיעוד בבית החל מתאריך:";
  const capacityText = "היקף השעות:";
  const initiativeText = "על פי יוזמה של:";
  const providerText = "נותן שירות";
  const text = record
    ? `${startText} ${moment(record.effective_from).format(
        "DD/MM/YYYY"
      )} ${capacityText} ${Math.round(
        record.required_weekly_minutes / 60
      ).toFixed(1)} `
    : ``;

  return (
    <div>
      <div>
        <Text>{text}</Text>
      </div>
      {startOfTrom ? (
        <div>
          <Text>{`${initiativeText} ${providerText}`}</Text>
        </div>
      ) : null}

      {record && record.order_service_type_id && startOfTrom ? (
        <div>
          <Text>{`${serviceText} ${serviceType}`}</Text>
        </div>
      ) : null}
    </div>
  );
};

export default ServiceDetails;
